import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/assessments/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/assessments/"!</div>;
}
